// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__16HLa","withError":"styles_withError__3Huig","withOutError":"styles_withOutError__1vGFD","content":"styles_content__1s7wG"};